export default "__VITE_ASSET__88e8af83__"